import React from 'react';

// Components
import ErrorBoundryComponent from '../pages/auth/ErrorBoundry';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div>
          <ErrorBoundryComponent />
        </div>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
